export default angular
  .module("ConfirmationCtrl", [
    "ui.bootstrap",
  ])
  .controller("ConfirmationController", [
    "$rootScope",
    "$scope",
    "$modalInstance",
    "title",
    "bodyContent",
    function (
      $rootScope,
      $scope,
      $modalInstance,
      title,
      bodyContent,
    ) {
      $scope.title = title;
      $scope.bodyContent = bodyContent;
      $scope.confirm = () => $modalInstance.close({ action: "confirm", payload: {} });
      $scope.cancel = () => $modalInstance.dismiss({ action: "cancel", payload: {} });
    },
  ]);
